export class EdgeComparerByTarget {
    constructor(X) {
        this.x = X;
    }
    Compare(a, b) {
        const r = this.x[a.Target] - this.x[b.Target];
        if (r !== 0)
            return r;
        return this.x[a.Source] - this.x[b.Source];
    }
}
//# sourceMappingURL=edgeComparerByTarget.js.map